import React from 'react'
import Header from 'components/template/Header'
import UserDropdown from 'components/template/UserDropdown'
import HeaderLogo from 'components/template/HeaderLogo'

const HeaderActionsStart = () => {
    return <HeaderLogo />
}

const HeaderActionsEnd = () => {
    return <UserDropdown hoverable={false} />
}

const PortalLayout = ({ children }) => {
    return (
        <div className="app-layout-portal flex flex-auto flex-col min-h-screen">
            <div className="flex flex-auto min-w-0">
                <div className="flex flex-col flex-auto min-h-screen min-w-0 relative w-full">
                    <Header
                        container
                        className="shadow dark:shadow-2xl"
                        headerStart={<HeaderActionsStart />}
                        headerEnd={<HeaderActionsEnd />}
                    />
                    {children}
                </div>
            </div>
        </div>
    )
}

export default PortalLayout
